import { RemotePositionCountForEntity } from 'data/usecases';
import { PositionCountForEntityUseCaseInterface } from 'domain/usecases';
import { makeApiUrlAdminEntity } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemotePositionCountForEntity =
  (): PositionCountForEntityUseCaseInterface =>
    new RemotePositionCountForEntity(
      makeApiUrlAdminEntity(),
      makeAxiosHttpClient(),
    );
